import React, { Component } from "react";
import Download from "../Download/download";
import { Translate } from "react-localize-redux";
import { Link } from "react-router-dom";

class Footer extends Component {
  getYear() {
    return new Date().getFullYear();
  }

  render() {
    if (typeof window !== "undefined") {
      const isMymobiPage =
        window.location.pathname === "/sonsy/mymobi" ||
        window.location.pathname === "/mobi/newyear" ||
        window.location.pathname === "/app" ||
        window.location.pathname === "/contents/showlink";
      if (isMymobiPage) return null;
    }
    return (
      <footer>
        <section className="newsletter-sec">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
                <div className="logo-footer">
                  <div className="">
                    <img src="/img/logo.png" alt="" width="120" height="40" style={{display: 'block'}} />
                    <div className="download-container">
                      <Download />
                    </div>
                  </div>
                </div>
              </div>
              <div className="marginTop col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                <img src="/img/download-qr.png" alt="qr" className="download-qr"  style={{display: 'block'}} />
              </div>
              <div className="marginTop col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                <h3 className="newsletter-heading">
                  <Translate id="footer.help" />
                </h3>
                <Link to="/help/tos" title="">
                  <p className="newsletter-text">
                    <Translate id="footer.terms-of-service" />
                  </p>
                </Link>
                <Link to="/contact" title="">
                  <p className="newsletter-text">
                    <Translate id="footer.contact-us" />
                  </p>
                </Link>
              </div>
              <div className="marginTop col-12 col-sm-6 col-md-4 col-lg-3 col-xl-4">
                <h3 className="newsletter-heading">
                  <Translate id="footer.contact-us" />
                </h3>
                <p className="newsletter-text">
                  <Translate id="footer.phone" />
                </p>
                <p className="newsletter-text">
                  <Translate id="footer.email" />
                </p>
                <p className="newsletter-text">
                  <Translate id="footer.address" />
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="footer-copyright-section">
          <div className="container">
            <div className="footer-content">
              <div className="footer-copyright">
                &copy; {process.env.REACT_APP_NAME} {this.getYear()}
              </div>
              <ul className="social-links">
                <li>
                  <a
                    href="mailto:contact@sonsy.mn"
                    title="google-plus"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/sonsymusic"
                    title="facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/sonsymusic/"
                    title="instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </footer>
    );
  }
}

export default Footer;
